export default "__VITE_PUBLIC_ASSET__ad5da60f__"